import React from "react";
import SettingsContainer from "../containers/SettingsContainer";

export const SettingsPage: React.FunctionComponent = () => <SettingsContainer />;